module.exports = __webpack_public_path__ + "static/media/Apple iPhone 8 Plus Gold.ad3de75a.png";